import { useEffect, useState } from "react";
import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaBookOpen } from "react-icons/fa6";
import defaultCover from "../../../assets/blog-default-cover.png";
import routePaths from "../../../routes/routePaths";

export default function HomeBlogPreview() {
  const [posts, setPosts] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      const q = query(
        collection(db, "blogs"),
        where("status", "==", "published"),
        orderBy("createdAt", "desc"),
        limit(3)
      );
      const snap = await getDocs(q);
      const data = snap.docs.map(doc => doc.data());
      setPosts(data);
    };
    fetchPosts();
  }, []);

  return (
    <section className="py-14 px-4 text-center bg-bg">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-extrabold text-primary mb-8">
          {t("home.blogSectionTitle")}
        </h2>
        <ul className="flex flex-col md:flex-row gap-6 justify-center items-stretch mb-7">
          {posts.map((post, idx) => (
            <li
              key={idx}
              className="
                flex-1 bg-card rounded border border-border 
                shadow-sm group hover:shadow-md hover:border-primary 
                transition cursor-pointer p-0 flex flex-col justify-between
                max-w-md
              "
              onClick={() => navigate(`/blog/${post.slug}`)}
            >
              {/* Cover image */}
              <div className="rounded-t-2xl overflow-hidden aspect-[16/9]">
                <img
                  src={post.coverImage || defaultCover}
                  alt={post.title?.[i18n.language] || post.title?.vi}
                  className="w-full h-full object-cover transition group-hover:scale-105 duration-300"
                  loading="lazy"
                />
              </div>
              {/* Nội dung text */}
              <div className="p-6 flex flex-col flex-1 justify-between">
                <div>
                  <div className="flex items-center justify-center mb-3">
                    <FaBookOpen className="text-primary text-2xl mr-2" />
                    <span className="text-primary font-bold text-base">{t("home.blog")}</span>
                  </div>
                  <div className="text-menu text-lg font-bold mb-2 group-hover:text-primary transition">
                    {post.title?.[i18n.language] || post.title?.vi}
                  </div>
                  <div className="text-text2 text-sm line-clamp-3">
                    {post.description?.[i18n.language] || post.description?.vi}
                  </div>
                </div>
                <div className="mt-4 text-right">
                  <span className="text-textLink font-semibold group-hover:text-secondary transition text-sm">
                    {t("home.readMore")}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <button
          className="
            bg-primary hover:bg-secondary 
            text-textButton font-bold 
            px-8 py-2 rounded shadow-sm 
            transition text-base
          "
          onClick={() => navigate(routePaths.blog)}
        >
          {t("home.allPosts")}
        </button>
      </div>
    </section>
  );
}
